import { render, staticRenderFns } from "./PostShare.vue?vue&type=template&id=dcad601e&"
import script from "./PostShare.vue?vue&type=script&lang=js&"
export * from "./PostShare.vue?vue&type=script&lang=js&"
import style0 from "./PostShare.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports